<template>
  <div id="app">
    <div v-if="showNav" class="absolute top-0 w-full flex justify-center">
      <a :href="this.sellerXurl" target="_blank" style="color:white;">{{sellerXname}}</a>
    </div>
    <div v-if="showNav" class="absolute top-5 float-right right-5" style="z-index: 98;">
      <button class="btn btn-light border-2 border-white" style="z-index: 99;"  @click="authorize" ref="connectWalletButton" v-if="customerAcc == null">Sign in <img class="xaman-icon" src="./assets/images/xaman-icon.jpg"/></button>
      <button class="btn btn-light border-2 border-white" style="z-index: 99;"  @click="logout" ref="disconnectWalletSpan" v-if="customerAcc !== null">Sign out <img class="xaman-icon" src="./assets/images/xaman-icon.jpg"/></button>
    </div>
    <div v-if="!showNav" class="flex justify-between p-8" style="z-index: 98;">
      <div class="flex justify-start">
        <a href="/admin/orders" class="btn btn-nav">Orders</a>
        <a href="/admin/grid" class="btn btn-nav">Grid</a>
      </div>
      <button class="btn btn-light border-2 border-white" style="z-index: 99;"  @click="logoutAdmin" >Log out</button>
    </div>
    <div v-if="showNav" class="header">
      <img class="main-logo" src="./assets/images/million-pixel-xrp-logo.png" />
      <img class="saturn" src="./assets/images/saturn.png"/>
      <img class="xrpl-bubble" src="./assets/images/xrpl-bubble.png"/>
    </div>
    <MainNav v-if="showNav" :customerAcc="customerAcc"/>
    <router-view 
      :customerAcc="customerAcc" 
      :authorize="authorize" 
      :hexEncode="hexEncode" 
      :isValidUrl="isValidUrl" 
      :isValidXRPAddress="isValidXRPAddress" 
      :urlPattern="urlPattern"
      :hexDecode="hexDecode"
      :network="network"
      :apiBase="apiBase"
    />
    <MainFooter />
    <!-- Terms Bar -->
    <div 
      v-if="showTermsBar" 
      class="sticky bottom-0 left-0 w-full bg-white p-4" style="z-index: 910; color: #414066;">
      <div class="container mx-auto flex flex-col sm:flex-row justify-center items-center gap-2">
        <p class="text-sm">
          By using this site, you agree to our 
          <a :href="`${baseUrl}terms`" class="underline text-blue-400 hover:text-blue-300">Terms & Conditions</a>.
        </p>
        <button 
          @click="acceptTerms" 
          class="btn btn-light" style="font-size: 1rem; line-height: 1rem;">
          Accept
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import MainNav from './components/MainNav.vue'
import MainFooter from './components/MainFooter.vue'
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useRouter } from 'vue-router';
import axios from "axios";
import { toast } from 'vue3-toastify';

export default {
  name: 'App',
  components: {
    MainNav,
    MainFooter
  },
  data () {
    return {
      customerAcc: null,
      urlPattern: 'https?://.*',
      paymentInfo: [],
      network: process.env.VUE_APP_NETWORK,
      sellerXurl : process.env.VUE_APP_SELLER_X_URL,
      sellerXname : process.env.VUE_APP_SELLER_X_NAME,
      showTermsBar: false, // Controls visibility of terms bar
      apiBase: process.env.VUE_APP_API_BASE
    }
  },
  setup() {
    const route = useRoute();
    const router = useRouter(); // Make sure it's defined

    // Define routes where Nav should be hidden
    const hiddenRoutes = [
      /^\/admin/ // Matches any route that starts with /admin
    ];

    // Compute whether to show Nav or not
    const showNav = computed(() => {
      return !hiddenRoutes.some(routePattern =>
        routePattern.test(route.path)
      );
    });

    const logoutAdmin = async () => {
      try {
        const token = localStorage.getItem("token"); // Get the token from localStorage

        const response = await axios.post(`${process.env.VUE_APP_API_BASE}/logout`, {}, {
          headers: {
            Authorization: `Bearer ${token}`  // Send token in Authorization header
          }
        });
    
        if (response.status === 200 && response.data?.level === 'success') {
          toast.success('Logout successful.');
        } else {
          toast.warning('Unexpected error. Please try again.');
        }

        localStorage.removeItem("token"); // Clear token
        router.push("/login"); // Redirect to login page

      } catch (error) {
        console.error("Logout failed:", error);
        toast.error("Logout failed. Please try again.");
      }
    };

    return { showNav, logoutAdmin };
  },
  mounted () {
    window.xumm.on("success", async () => {
      window.xumm.user.account.then(account => {
        this.customerAcc = account
      })
    })

    window.xumm.on("logout", async () => {
      this.customerAcc = null
    })

    // Check if the terms were already accepted
    if (!document.cookie.includes("accepted_terms=true")) {
      this.showTermsBar = true
    }
  },
  methods: {
    authorize() {
      window.xumm.authorize()
    },
    logout() {
      window.xumm.logout()
    },
    formatAccount(account) {
      // This will format the account string as specified
      return account.substring(0, 3) + '...' + account.substring(account.length - 3)
    },
    hexEncode(data) {
      // Convert the object to a JSON string
      const str = JSON.stringify(data);
      
      // Convert each character to hexadecimal
      let hex = '';
      for (let i = 0; i < str.length; i++) {
        hex += str.charCodeAt(i).toString(16).padStart(2, '0');
      }
      return hex;
    },
    hexDecode(hex) {
      // Convert the hexadecimal string back to a JSON string
      let str = '';
      for (let i = 0; i < hex.length; i += 2) {
        str += String.fromCharCode(parseInt(hex.substring(i, i + 2), 16));
      }
      
      // Parse the JSON string back into an object
      return JSON.parse(str);
    },
    isValidUrl(url) {
      // Basic validation for URL format
      const urlRegex = /^(https?:\/\/[^\s$.?#].[^\s]*)$/i;
      return urlRegex.test(url);
    },
    isValidXRPAddress(address) {
      // Regular expression for validating XRP address format (Base58Check encoding)
      const regex = /^r[1-9A-HJ-NP-Za-km-z]{33}$/;
      
      // Check if address matches the regex pattern
      return regex.test(address);
    },
    acceptTerms() {
      document.cookie = "accepted_terms=true; path=/; max-age=" + 60 * 60 * 24 * 365 // 1 year
      this.showTermsBar = false
    },
  }
}
</script>

<style>
  @tailwind base;
  @tailwind components;
  @tailwind utilities;
  
  @font-face {
    font-family: 'Joystick';
    src: url('~@/assets/fonts/joystix\ monospace.otf');
  }

  /* ----------------------------------------------
 * Generated by Animista on 2025-2-5 16:49:20
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation rotate-scale-up
 * ----------------------------------------
 */

  @-webkit-keyframes jelly-wiggle {
      0%, 80% { transform: scale(1, 1); } /* Stay still for most of the time */
      85% { transform: scale(1.2, 0.8) skewX(10deg); }
      90% { transform: scale(0.8, 1.2) skewX(-10deg); }
      95% { transform: scale(1.1, 0.9) skewX(5deg); }
      100% { transform: scale(1, 1); }
  }

  @keyframes jelly-wiggle {
      0%, 80% { transform: scale(1, 1); } /* Stay still for most of the time */
      85% { transform: scale(1.2, 0.8) skewX(10deg); }
      90% { transform: scale(0.8, 1.2) skewX(-10deg); }
      95% { transform: scale(1.1, 0.9) skewX(5deg); }
      100% { transform: scale(1, 1); }
  }

  @keyframes orbit {
      0% { transform: rotate(0deg) translateX(15px) rotate(0deg); }
      100% { transform: rotate(360deg) translateX(15px) rotate(-360deg); }
  }

  @-webkit-keyframes orbit {
      0% { transform: rotate(0deg) translateX(15px) rotate(0deg); }
      100% { transform: rotate(360deg) translateX(15px) rotate(-360deg); }
  }

  @media (max-width: 786px)  {
    html, body {
      overflow: hidden;
      overscroll-behavior: none;
      touch-action: manipulation;
    }
  }

  .saturn {
    position: absolute; 
    top: 80px; 
    left: 10vw; 
    width: min(15vw, 200px);
    transform-origin: center;
    -webkit-animation: orbit 10s linear infinite;
    animation: orbit 10s linear infinite;
  }

  .xrpl-bubble {
    position: absolute; 
    top: 90px; 
    right: 10vw; 
    width: min(15vw, 200px);
    -webkit-animation: jelly-wiggle 4s ease-in-out infinite;
    animation: jelly-wiggle 4s ease-in-out infinite;
  }

  #app {
    font-family: 'Chakra Petch', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: white;
    margin: 0;
    background: #414066;
    background-image: url('./assets/images/stars-pattern.png');
    background-repeat: repeat;
    background-size: auto 100%;
    background-size: 400px;
    min-height: 100vh;
  }

  body {
    margin: 0;
    font-family: 'Chakra Petch';
    color: inherit;
    width: 100vw;
    transform-origin: top left; /* Ensure scaling starts from the top-left corner */
    transform: scale(1);
    min-height: 100vh;
  }
  
  a {
    color: #3185FC;
    text-decoration: underline;
  }

  .lazy-load {
    opacity: 0;
    transition: opacity 0.5s ease-in-out;
    will-change: opacity;
    min-height: 100px; /* Prevents layout shift */
    background: url('./assets/images/loading-spinner.svg') center center no-repeat;
    background-size: 30px;
  }

  .lazy-load.loaded {
    opacity: 1;
    background: none; /* Remove loading indicator once loaded */
  }

  .header {
    display: flex;
    justify-content: center;
    margin: auto;
    position: relative;
    width: 100%;
    padding-top: min(8vh, 100px);
  }

  .header .main-logo {
    width: min(200px, 30vw);
  }

  .btn {
    letter-spacing: 0.1rem;
    cursor: pointer;
    font-size: 1.1rem;
    padding: 5px 20px;
    margin: 5px;
  }

  .btn-multi {
    min-width: 6rem;
  }

  .btn-light {
    font-family: inherit;
    color: white;
    background: #3185FC;
    display: flex;
    font-weight: bold;
    line-height: 1.6rem;
    justify-content: center;
    font-size: 1.1rem;
    letter-spacing: 0.1rem;
    align-items: center;
  }

  .btn-light .xaman-icon {
    width: 1.6rem;
    height: 1.6rem;
    margin-left: 10px;
  }

  .btn-outline-light {
    font-family: inherit;
    color: #3185FC;
    background: white;
    border: solid 2px #3185FC;
    text-decoration: none;
    align-items: center;
  }

  .btn-secondary {
    font-family: inherit;
    color: white;
    background: #b1b0b0;
    display: flex;
    place-items: center;
    line-height: 1.6rem;
    justify-content: center;
    font-size: 1.1rem;
    letter-spacing: 0.1rem;
    align-self: center;
    align-items: center;
  }

  .btn-nav {
    color: #3185FC;
    text-decoration: none;
    background: white;
    font-weight: bold;
  }

  .btn-edit {
    color: #3185FC;
    text-decoration: underline;
    border: solid 2px #3185FC;
  }

  .btn-danger {
    background: white;
    color: red;
    border: 2px solid red;
    text-decoration: none;
    align-items: center;
  }

  .btn-danger:hover {
    background: red;
    color: white;
    border: 2px solid white;
  }

  .btn-admin {
    padding: 15px 20px;
    font-weight: 400;
  }
  
  .btn-admin img{
    height: 32px;
    margin-left: 10px;
  }

  .btn-form {
    padding: 8px 20px;
  }

  .info-container,
  .profile {
    background-color: #414066;
    padding: 1rem;
    margin:auto;
    text-align: left;
  }

  .info-container h1,
  .profile h1 {
    text-align: left;
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 1rem;
  }

  .info-container h2,
  .profile h2 {
    text-align: left;
    font-size: 1.5rem;
    margin-top: 1rem;
  }

  .info-container p {
    text-align: left;
  }

  .info-container .step {
    font-size: 1.2rem; 
    font-weight: bold;
  }

  .info-container ul li {
    margin-top: 1rem;
  }

  .Toastify {
    position: absolute;
    top: 0;
    width: 100%;
  }

  .Toastify__toast-container,
  .Toastify__toast-container--top-right{
    position: relative !important;
    top: 1.25rem !important;
    right: 1.25rem !important;
    font-family:'Chakra Petch'!important; /* Change font family globally */
    width: min(85vw,400px)!important;
    float: right !important;
  }

  .Toastify__toast {
    border-radius: 0px!important; /* Round the toast corners */
    font-family:'Chakra Petch'!important;
    color: #000!important;
    font-size: large;
  }

  .Toastify__toast--success {
    background-color: #28a745;  /* Green for success toasts */
  }

  .Toastify__toast--error {
    background-color: #dc3545;  /* Red for error toasts */
  }

  .Toastify__toast--error .toastify-icon {
    background-image: url('@/assets/images/icon-error.png');
  }

  .Toastify__toast--info {
    background-color: #17a2b8;  /* Blue for info toasts */
  }

  .Toastify__toast--warning {
    background-color: #ffc107;  /* Yellow for warning toasts */
  }

  .input-warning {
    border: 2px solid #ffc107;
  }

  .input-error {
    border: 2px solid #dc3545;
  }

  .modal-bg {
    z-index: 101;
  }

  .modal-content {
    position: relative;
  }

  .modal-content .btn-close {
    float: right;
  }

  .drag-area .on-drop,
  .drag-area.dragover .visible {
    display: none;
  }

  .error {
    color: #dc3545;
  }

  .modal-header {
    margin-top: 30px;
    color: #414066;
  }

  .modal-content {
    color: #414066;
  }

  .modal-header h1 {
    justify-self: center;
  }

  .modal-content .progress-wrapper {
    margin: 30px auto;
    height: 20px;
    background-color: lightgray;
    overflow: hidden;
  }

  .modal-content .progress-wrapper .progress-bar {
    height: 20px;
    background-color: #3185fc;
    color: white;
    text-align: right;
    line-height: 20px;
    transition: width 0.5s ease-in-out; /* Smooth transition */
    font-size: 12px;
  }

  .modal-content,
  .modal-content .progress-wrapper .progress-bar p {
    float: right;
    transition: width 0.4s ease-in-out; /* Smooth transition */
  }

  .modal-content .step h2 {
    margin: 30px auto;
    color: #414066;
  }

  .modal-content .image-select,
  .modal-content .image-wrapper {
    width: 90%;
    height: 200px;
    background-color: white;
    margin: auto;
    position: relative;
    font-size: 16px;
    line-height: 30px;
  }

  .modal-content .image-wrapper .preview {
    height: 200px;
  }

  .modal-content .image-wrapper .btn-remove {
    float: unset;
    background: white;
    padding: 5px 20px;
    opacity: 0.8;
    top: 40%;
    position: absolute;
    margin: auto;
  }

  .modal-content .step-1 input {
    display: none;
  }

  .modal-content input:focus,
  .modal-content input:focus-visible,
  .admin-input {
    border: solid 2px #3185fc;
    border-radius: 0;
    outline: none;
    border-color: #3185fc;
    box-shadow: 0 0 3px #3185fc;
    -moz-box-shadow: 0 0 3px #3185fc;
    -webkit-box-shadow: 0 0 3px #3185fc;
    color: #414066;
  }

  .modal-content input,
  .admin-input {
    border: solid 2px #3185fc;
    padding: 5px;
    width: 100%;
    margin: auto;
    margin-bottom:  10px;
    color: #414066;
  }

  .modal-content label {
    font-size: small;
  }

  .modal-content .form-group-wrapper {
    margin-top: 30px;
    display: flex;
    justify-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
  }

  .modal-content .form-group-wrapper .form-group {
    width: 80%;
    position: relative;
    margin: auto;
  }

  label {
    margin-bottom: 5px;
  }

  .modal-fade-enter-active, .modal-fade-leave-active {
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  .modal-fade-enter-from, .modal-fade-leave-to {
    opacity: 0;
    transform: scale(0.9);
  }

  .form-group {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    width: 100%;
    max-width: 400px;
    position: relative;
  }

  .icon-for-input {
    color: #3185fc;
    font-size: 20px;
    margin-right: 10px;
    position: absolute;
    left: 20px;
    top: 40%;
    transform: translateY(-50%);
  }

  .modal-content .input-with-icon {
    padding: 5px 5px 5px 36px; /* Ensure text doesn't overlap icon */
  }

  .fade-center-enter-active, .fade-center-leave-active {
    transition: all 0.3s ease;
  }

  .fade-center-enter-from {
    opacity: 0;
    transform: scale(0.9);
  }

  .fade-center-leave-to {
    opacity: 0;
    transform: scale(1.1);
  }

  .pixel-corners,
  .pixel-corners--wrapper {
  clip-path: polygon(0px calc(100% - 12px),
    3px calc(100% - 12px),
    3px calc(100% - 6px),
    6px calc(100% - 6px),
    6px calc(100% - 3px),
    12px calc(100% - 3px),
    12px 100%,
    calc(100% - 12px) 100%,
    calc(100% - 12px) calc(100% - 3px),
    calc(100% - 6px) calc(100% - 3px),
    calc(100% - 6px) calc(100% - 6px),
    calc(100% - 3px) calc(100% - 6px),
    calc(100% - 3px) calc(100% - 12px),
    100% calc(100% - 12px),
    100% 12px,
    calc(100% - 3px) 12px,
    calc(100% - 3px) 6px,
    calc(100% - 6px) 6px,
    calc(100% - 6px) 3px,
    calc(100% - 12px) 3px,
    calc(100% - 12px) 0px,
    12px 0px,
    12px 3px,
    6px 3px,
    6px 6px,
    3px 6px,
    3px 12px,
    0px 12px);
  position: relative;
}
.pixel-corners {
  border: 3px solid transparent;
}
.pixel-corners--wrapper {
  width: fit-content;
  height: fit-content;
}
.pixel-corners--wrapper .pixel-corners {
  display: block;
  clip-path: polygon(3px 12px,
    6px 12px,
    6px 6px,
    12px 6px,
    12px 3px,
    calc(100% - 12px) 3px,
    calc(100% - 12px) 6px,
    calc(100% - 6px) 6px,
    calc(100% - 6px) 12px,
    calc(100% - 3px) 12px,
    calc(100% - 3px) calc(100% - 12px),
    calc(100% - 6px) calc(100% - 12px),
    calc(100% - 6px) calc(100% - 6px),
    calc(100% - 12px) calc(100% - 6px),
    calc(100% - 12px) calc(100% - 3px),
    12px calc(100% - 3px),
    12px calc(100% - 6px),
    6px calc(100% - 6px),
    6px calc(100% - 12px),
    3px calc(100% - 12px));
}
.pixel-corners::after,
.pixel-corners--wrapper::after {
  content: "";
  position: absolute;
  clip-path: polygon(0px calc(100% - 12px),
    3px calc(100% - 12px),
    3px calc(100% - 6px),
    6px calc(100% - 6px),
    6px calc(100% - 3px),
    12px calc(100% - 3px),
    12px 100%,
    calc(100% - 12px) 100%,
    calc(100% - 12px) calc(100% - 3px),
    calc(100% - 6px) calc(100% - 3px),
    calc(100% - 6px) calc(100% - 6px),
    calc(100% - 3px) calc(100% - 6px),
    calc(100% - 3px) calc(100% - 12px),
    100% calc(100% - 12px),
    100% 12px,
    calc(100% - 3px) 12px,
    calc(100% - 3px) 6px,
    calc(100% - 6px) 6px,
    calc(100% - 6px) 3px,
    calc(100% - 12px) 3px,
    calc(100% - 12px) 0px,
    12px 0px,
    12px 3px,
    6px 3px,
    6px 6px,
    3px 6px,
    3px 12px,
    0px 12px,
    0px 50%,
    3px 50%,
    3px 12px,
    6px 12px,
    6px 6px,
    12px 6px,
    12px 3px,
    calc(100% - 12px) 3px,
    calc(100% - 12px) 6px,
    calc(100% - 6px) 6px,
    calc(100% - 6px) 12px,
    calc(100% - 3px) 12px,
    calc(100% - 3px) calc(100% - 12px),
    calc(100% - 6px) calc(100% - 12px),
    calc(100% - 6px) calc(100% - 6px),
    calc(100% - 12px) calc(100% - 6px),
    calc(100% - 12px) calc(100% - 3px),
    12px calc(100% - 3px),
    12px calc(100% - 6px),
    6px calc(100% - 6px),
    6px calc(100% - 12px),
    3px calc(100% - 12px),
    3px 50%,
    0px 50%);
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #3185fc;
  display: block;
  pointer-events: none;
}
.pixel-corners::after {
  margin: -3px;
}
</style>
